import Reveal from "./Reveal";
import Eyebrow from "./Eyebrow";

const u = (id) =>
    `https://images.unsplash.com/photo-${id}?auto=format&w=900&q=80`;

const WORKS = [
    { id: 1, label: "Kamera arkası", img: u("1587050265310-1a2d98ccce5f"), alt: "Video kamera ile çekim yapan ekip üyesi" },
    { id: 2, label: "Mutfak", img: u("1663530761401-15eefb544889"), alt: "Tabağa sos döken şef" },
    { id: 3, label: "Fitness", img: u("1676655079738-af54dfd6318e"), alt: "Karanlık antrenman salonunda sporcu" },
    { id: 4, label: "Ürün çekimi", img: u("1554941829-202a0b2403b8"), alt: "Stüdyoda ürün çekimi" },
    { id: 5, label: "Kurgu", img: u("1594199690258-c5d8abe06c0b"), alt: "Video kurgu yapılan masa" },
    { id: 6, label: "Güzellik", img: u("1761718210089-ba3bb5ccb54f"), alt: "Cilt bakımı seansı" },
    { id: 7, label: "Saha çekimi", img: u("1493863641943-9b68992a8d07"), alt: "Fotoğraf makinesiyle sokakta çekim" },
    { id: 8, label: "Perakende", img: u("1582719188393-bb71ca45dbb9"), alt: "Mağaza vitrininde kıyafetler" },
    { id: 9, label: "Ekip", img: u("1758691737124-05c5bffe46f0"), alt: "Dizüstü bilgisayar başında çalışan ekip" },
    { id: 10, label: "Ekipman", img: u("1502982720700-bfff97f2ecac"), alt: "Kamera ve lens" },
];

export default function Work() {
    return (
        <section id="calismalar" data-testid="portfolio-gallery-section" className="scroll-mt-24 bg-coal py-24 md:py-32">
            <div className="mx-auto w-full max-w-[1240px] px-6 md:px-10">
                <div className="grid gap-8 md:grid-cols-2 md:gap-12">
                    <Reveal>
                        <Eyebrow>Çalışmalar</Eyebrow>
                        <h2 className="mt-5 font-display text-4xl leading-tight text-cream sm:text-5xl lg:text-6xl">
                            Kadrajdan çıkanlar.
                        </h2>
                    </Reveal>
                    <Reveal delay={0.1} className="md:pt-14">
                        <p className="max-w-md text-base leading-relaxed text-fog md:text-lg">
                            Kamera arkasından ve sahadan seçili kareler.
                        </p>
                    </Reveal>
                </div>

                <div className="mt-14 columns-1 gap-4 sm:columns-2 lg:columns-3">
                    {WORKS.map((w) => (
                        <Reveal key={w.id} className="mb-4 break-inside-avoid md:mb-5">
                            <figure data-testid={`work-item-${w.id}`} className="group overflow-hidden bg-charcoal">
                                <img
                                    src={w.img}
                                    alt={w.alt}
                                    loading="lazy"
                                    decoding="async"
                                    className="w-full transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                                />
                                <figcaption className="flex items-center gap-2 py-3 text-[11px] font-semibold uppercase tracking-[0.2em] text-fog">
                                    <span className="h-1 w-1 rounded-full bg-brick" aria-hidden="true" />
                                    {w.label}
                                </figcaption>
                            </figure>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
